import { createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils/Component';
const styles = (theme) => createStyles({
    sdfBackgroundContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: 0,
        margin: 0,
        position: 'relative',
        zIndex: 100,
        minHeight: '100vh',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    sdfLogo: {
        zIndex: 105,
        width: 240,
        marginBottom: 30,
    },
});
const SdfBackground = (props) => {
    const { classes, children, hideLogo, imagesBaseUrl } = props;
    const backgroundImage = {
        backgroundImage: `url(${imagesBaseUrl}/sdf/assets/images/account/sdf-background.jpg)`,
    };
    return (React.createElement("main", { className: classes.sdfBackgroundContainer, style: backgroundImage, "data-testid": 'sdf-page' },
        !hideLogo && (React.createElement("img", { alt: 'sdf', src: `${imagesBaseUrl}/sdf/assets/images/common/logo/logo_login_shadow.png`, className: classes.sdfLogo })),
        children));
};
export default compose(withBaseProps({ styles }))(SdfBackground);
//# sourceMappingURL=SdfBackground.js.map